// Generated file : do not modify
export enum DeliveryTypes
{
  NONE = 0,
  CHEQUE,
  VIREMENT,
  PRELEVEMENT_B2B,
  CARTE_BANCAIRE,
  PRELEVEMENT_B2C
};

import { ListFilter } from '@/extend/classes/ListData';
import Transaction from '@/extend/classes/Transaction';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Bordereaux bancaires
export default class Delivery  {
  // Identifiant unique
  public id: number;
  // Type
  public type: DeliveryTypes;
  // Référence du bordereau
  public reference: string;
  // RIB virement
  public ribId: number;
  // Date de relevé
  public dateDelivery: Date;
  // Date d'encaissement
  public datePayed: Date | null;
  // Montant
  public amount: number;
  // Nombre
  public count: number;
  // Destinataires
  public ownerType: number;
  // Ecriture bancaire
  public bankId: number;
  // Fichier téléchargé
  public xmlLoaded: boolean;
  // Contient des rejets
  public hasReject: boolean;
  // Id des transactions
  public transactionIds: number[];
  // Document associé
  public documentId: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.type = DeliveryTypes.NONE;
    this.reference = '';
    this.ribId = 0;
    this.dateDelivery = new Date(1901,1,1,0,0,0,0);
    this.datePayed = null;
    this.amount = 0;
    this.count = 0;
    this.ownerType = 0;
    this.bankId = 0;
    this.xmlLoaded = false;
    this.hasReject = false;
    this.transactionIds = [];
    this.documentId = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Delivery): Delivery {
    const newDelivery: Delivery = new Delivery();
    newDelivery.id = obj.id;
    newDelivery.type = obj.type;
    newDelivery.reference = obj.reference;
    newDelivery.ribId = obj.ribId;
    newDelivery.dateDelivery = new Date(obj.dateDelivery);
    newDelivery.datePayed = obj.datePayed ? new Date(obj.datePayed) : null;
    newDelivery.amount = obj.amount;
    newDelivery.count = obj.count;
    newDelivery.ownerType = obj.ownerType;
    newDelivery.bankId = obj.bankId;
    newDelivery.xmlLoaded = obj.xmlLoaded;
    newDelivery.hasReject = obj.hasReject;
    newDelivery.transactionIds = JSON.parse(JSON.stringify(obj.transactionIds));
    newDelivery.documentId = obj.documentId;
    newDelivery.createId = obj.createId;
    newDelivery.failed = obj.failed;
    newDelivery.canUpdate = obj.canUpdate;
    newDelivery.canDelete = obj.canDelete;
    newDelivery.display = obj.display;
    newDelivery.notifDefType = obj.notifDefType;
    return newDelivery;
  }

  public toJsonDelivery (): string {
    const json = {
      type: this.type,
      reference: this.reference,
      ribId: this.ribId,
      dateDelivery: this.dateDelivery ? new Date (this.dateDelivery).toString() : this.dateDelivery,
      datePayed: this.datePayed ? new Date (this.datePayed).toString() : this.datePayed,
      amount: this.amount,
      count: this.count,
      ownerType: this.ownerType,
      bankId: this.bankId,
      xmlLoaded: this.xmlLoaded,
      hasReject: this.hasReject,
      transactionIds: this.transactionIds,
      documentId: this.documentId,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromDelivery (obj: Delivery): void {
    this.id = obj.id;
    this.type = obj.type;
    this.reference = obj.reference;
    this.ribId = obj.ribId;
    this.dateDelivery = new Date(obj.dateDelivery);
    this.datePayed = obj.datePayed;
    this.amount = obj.amount;
    this.count = obj.count;
    this.ownerType = obj.ownerType;
    this.bankId = obj.bankId;
    this.xmlLoaded = obj.xmlLoaded;
    this.hasReject = obj.hasReject;
    this.transactionIds = obj.transactionIds;
    this.documentId = obj.documentId;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareDelivery (value: Delivery): boolean {
    return (this.toJsonDelivery() == value.toJsonDelivery());
  }

  public cloneDelivery (): Delivery {
    return Delivery.fromJson(this);
  }

  public createForStoreDelivery (): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/deliveries/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromDelivery(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreDelivery (): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/deliveries/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromDelivery(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/deliveries/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static checkDelivery (delivery: Delivery): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/deliveries/checkDelivery', delivery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Delivery.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static simuBank (delivery: Delivery): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/deliveries/simuBank', delivery, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(Delivery.fromJson(res.data));
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static rebuildVirement (removed: Transaction[]): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/deliveries/rebuildVirement', removed, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static generatePrelevement (): Promise<boolean> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/deliveries/generatePrelevement', getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Deliveries/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Delivery.fromJson(listData.reccords[0] as Delivery);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Delivery> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Deliveries/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Delivery.fromJson(listData.reccords[0] as Delivery);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(deliverys: Delivery[]) {
    deliverys.forEach((item) => {
      item.dateDelivery = item.dateDelivery ? new Date(item.dateDelivery) : item.dateDelivery;
      item.datePayed = item.datePayed ? new Date(item.datePayed) : item.datePayed;
    })
  }
}
